import React, { useRef, useState } from 'react';
import { RadioGroup, Heading } from '..';

export const NestedRadio = ({
  data = null,
  selectOption = () => {},
  onRadioInputChange = () => {},
}) => {
  const [radios, setRadios] = useState({ 0: data });
  const timerRef = useRef(null);

  const removeSelectedVal = (item) => {
    if (item?.radio?.source) {
      for (let i = 0; i < item.radio.source.length; i++) {
        removeSelectedVal(item.radio.source[i]);
      }
    }
    item?.radio?.selectedValue && delete item.radio.selectedValue;
    item?.input_box &&
      item.input_box.selectedInputValue &&
      delete item.input_box.selectedInputValue;
    item?.dropdown &&
      item.dropdown.selectedDropdownValue &&
      delete item.dropdown.selectedDropdownValue;
  };

  const updateRadio = (key, selectedItem, item, activeRadio) => {
    let filteredEles = activeRadio.source.filter((ele) => {
      if (String(ele.value) !== item.value) return ele;
      return true;
    });
    filteredEles.map((item) => removeSelectedVal(item));

    Object.keys(radios).map((index) => {
      if (index > key) {
        delete radios[index];
      }
      setRadios({ ...radios });
      return true;
    });
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      const newKey = key + 1;
      const newObj = {};
      if (item?.radio?.source) {
        newObj[newKey] = item.radio;
      }
      setRadios({ ...radios, ...newObj });

      return selectOption(item, radios[0]);
    }, 300);
  };

  return (
    <div className='col'>
      {Object.keys(radios).map((item, index) => {
        if (!radios[item]?.source?.length) return null;
        return (
          <div className='pb20 col' key={index}>
            {radios[item].title && <Heading title={radios[item].title.text} />}
            <RadioGroup
              key={index}
              items={radios[item].source}
              radio={radios[item]}
              selectOption={updateRadio.bind(this, index)}
              selectDropdown={onRadioInputChange}
              onRadioInputChange={onRadioInputChange}
            />
          </div>
        );
      })}
    </div>
  );
};
